<template>
  <form class="form form-join-place" @submit.prevent="postJoinPlace">
    <slide-x-left-transition :duration="400" :delay="200">
      <div class="form-group" v-show="show">
        <label>Numer NIP</label>
        <div class="input-wrapper">
          <input v-model="form.tax_id"
                 type="tel"
                 :class="{'input-error' : errors.tax_id }"
                 placeholder="Podaj NIP"
                 ref="taxIdInput"
                 required/>
        </div>
        <p class="error" v-if="errors.tax_id">{{ errors.tax_id[0] }}</p>
      </div>
    </slide-x-left-transition>
    <slide-x-left-transition :duration="500" :delay="300">
      <ion-button mode="ios" v-if="show" @click="getPlacesByTaxId" expand="block"
                  :disabled="loadingSearchButton">
        <span v-if="loadingSearchButton"><span class="loader"></span></span>
        <span v-else>Szukaj lokali</span>
      </ion-button>
    </slide-x-left-transition>

    <div class="text-center" v-show="showHiddenSelect && places.length === 0">
      <p><b>Brak lokali pod tym NIP.</b></p>
    </div>

    <slide-x-left-transition :duration="400" :delay="200">
      <div class="form-group" v-show="showHiddenSelect && places.length !== 0">
        <label>Lokal pod tym NIP</label>
        <div class="select-wrapper">
          <span v-if="form.place_slug === null" class="select-placeholder">Wybierz lokal</span>
          <select v-model="form.place_slug">
            <option v-for="item in places" :value="item.slug">{{ item.name }}</option>
          </select>
        </div>
        <p class="error" v-if="errors.place_slug">{{ errors.place_slug[0] }}</p>
      </div>
    </slide-x-left-transition>
    <slide-x-left-transition :duration="500" :delay="300">
      <div class="form-group" v-show="showHiddenSelect && places.length !== 0">
        <label>Rola</label>
        <div class="select-wrapper">
          <span v-if="form.role_slug === null" class="select-placeholder">Wybierz rolę</span>
          <select v-model="form.role_slug" required>
            <option v-for="item in roles" :value="item.slug">{{ item.name }}</option>
          </select>
        </div>
        <p class="error" v-if="errors.role_slug">{{ errors.role_slug[0] }}</p>
      </div>
    </slide-x-left-transition>
    <slide-x-left-transition :duration="600" :delay="400">
      <ion-button mode="ios" v-if="showHiddenSelect && places.length !== 0" expand="block" type="submit"
                  :disabled="loading || !(form.place_slug && form.role_slug)">
        <span v-if="loading"><span class="loader"></span></span>
        <span v-else>Dołącz</span>
      </ion-button>
    </slide-x-left-transition>

  </form>
</template>

<script>
  import api from '@/services/Api';
  import goTo from '@/mixins/goto';
  import {mapGetters, mapState} from 'vuex';

  function getDefaultFormData() {
    return {
      tax_id: null,
      place_slug: null,
      role_slug: null
    }
  }

  export default {
    name: 'FormJoinPlace',
    mixins: [goTo],
    data() {
      return {
        show: false,
        loading: false,
        errors: {},
        showHiddenSelect: false,
        loadingSearchButton: false,
        form: getDefaultFormData()
      }
    },
    computed: {
      ...mapState({
        roles: state => state.global.roles,
        places: state => state.global.places
      })
    },
    mounted() {
      this.show = true;
      if(this.roles.length === 0){
        this.$store.dispatch('GLOBAL_ROLES_REQUEST')
      }
    },
    methods: {
      getPlacesByTaxId() {
        this.loadingSearchButton = true;
        this.$store.dispatch('GLOBAL_PLACES_SEARCH_REQUEST', this.form.tax_id)
            .then(resp => {
              // REQUESTED: if only one place is to choose
              // select it automaticly
              if(this.places.length == 1){
                this.form.place_slug = this.places[0].slug
              }
              this.showHiddenSelect = true
              this.loadingSearchButton = false
            });
      },
      postJoinPlace() {
        this.loading = true;
        this.$store.dispatch('profile/PROFILE_PLACE_JOIN_REQUEST', this.form)
            .then(resp => {
              this.loading = false
              this.$store.dispatch('GLOBAL_TOAST','Wysłano prośbę o dołączenie do lokalu.')
              this.form = getDefaultFormData()
              this.goBack()
            })
            .catch(err => {
              this.loading = false
              this.errors = err.response.data.errors ? err.response.data.errors : []
            })
      }
    }
  }
</script>